
import { Component, Vue } from 'vue-property-decorator'
import { ContactUsImpl } from '../manages/ContactUsImpl'
import { ContactUsService } from '../services/HomeService'
@Component({
  components: {}
})
export default class ContactUs extends Vue {
    private manage = new ContactUsImpl(new ContactUsService())
    async mounted () {
      this.manage.requestContactUsData()
    }

    showTelUs () {
      return this.manage.ContactUsData.addr ||
        this.manage.ContactUsData.contactPerson ||
        this.manage.ContactUsData.tel ||
        this.manage.ContactUsData.email ||
        this.manage.ContactUsData.qrcode
    }
}
